<template>
  <div id="content" v-if="!loading">
    <div class="inner">
      <p class="paging">
        <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <h1 v-translate>Přidat skupinu uživatelských oprávnění</h1>
    </div>
    <div class="responsiveTabs">
      <div class="tabs_content">
        <section>
          <div class="left">
            <h2 v-translate>Základní údaje</h2>
          </div>
          <div class="right">
            <role-groups-basic-form
                :entity="entity"
                :is-editable="isEditable"
                ref="roleGroupsBasicFormRef"
            />
            <role-groups-select-list
                v-model="entity.roles"
                :is-editable="isEditable"
                :edit-allowed-sections="edit_allowed_section_list"
                ref="roleGroupsBasicFormRef"
            />
          </div>
        </section>
        <section class="buttons">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
            </router-link>
            <input type="submit" :value="'Uložit' | translate"
                   :class="['btn']"
                   @click.prevent.stop="createEntity()">
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import RoleGroupsBasicForm from "./forms/RoleGroupsBasicForm";
import RoleGroupsSelectList from "./forms/RoleGroupsSelectList";
import detailActions from "@/components/mixins/detail-actions";
import roleGroups from "./mixins/roleGroups";

export default {
  name: "RoleGroupsNew",
  mixins: [detailActions, roleGroups],
  components: {RoleGroupsBasicForm, RoleGroupsSelectList},
  created(RoleGroupsService) {
    this.entityService = RoleGroupsService;
    this.getEditAllowedSectionList();
    if (this.$route.query.duplicate) {
      this.entityService.getEntity(this.$route.query.duplicate, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then((data) => {
            this.entity = data.roleGroup;
            this.entity.name += " (copy)";
            this.entity.code += "_copy";
            this.loading = false;
          })
          .catch((e) => {
            this.setErrorMessage(e.message);
          });
    } else {
      this.loading = false;
    }
  },
  computed: {
    isEditable() {
      return true;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/RoleGroupsNew.vue